import { SelectGroup } from "@appretio/ui-kit";
import React, { useCallback } from "react";
import type {
  TemporalContext,
  TemporalContextField
} from "./data/temporalContextOptions";
import {
  type TemporalConfig,
  temporalConfig
} from "./data/temporalContextOptions";
import { TemporalContextDropdown } from "./TemporalContextDropdown";

interface TemporalContextSelectorProps {
  /**
   * Currently selected options for each temporal context field
   */
  selected?: TemporalContext;
  /**
   * Sets selected options for each temporal context field
   */
  setSelected: React.Dispatch<React.SetStateAction<TemporalContext>>;
}

export function TemporalContextSelector({
  selected,
  setSelected
}: TemporalContextSelectorProps) {
  // Memoize onChange handler
  const handleSetSelected = useCallback(
    (field: TemporalContextField, value: string | string[] | undefined) => {
      setSelected((prev) => ({ ...prev, [field]: value }));
    },
    [setSelected]
  );

  return (
    <SelectGroup>
      {(
        Object.entries(temporalConfig) as Array<
          [TemporalContextField, TemporalConfig]
        >
      ).map(([field, config]) => {
        const selectedOptions = selected?.[field];

        return (
          <TemporalContextDropdown
            key={field}
            field={field}
            config={config}
            selected={selectedOptions}
            setSelected={handleSetSelected}
          />
        );
      })}
    </SelectGroup>
  );
}
